<template>
  <div class="download-ios">
    <LayoutHeader />
    <img
      v-if="language === 'zh'"
      class="download-bg"
      src="../assets/images/ios-bg-zh.png"
    />

    <img
      v-if="language === 'en'"
      class="download-bg"
      src="../assets/images/ios-bg-en.png"
    />

    <section class="download-wrap">
      <img class="download-logo" src="../assets/images/ios-store.png" />
      <div class="download-content">
        <div class="download-title">TokenPocket</div>
        <div class="download-version">
          <span>App Store</span>
          V{{ versionInfo.ios_a }}
        </div>
      </div>
      <!-- <div class="download-btn">
        <span @click="goAppStore">{{ $t("common.download") }}</span>
      </div> -->
      <div class="download-btn" @click="goAppStore">
        <img class="apple" src="../assets/images/apple.png" />
        <div class="right">
          <span>Download on the</span>
          <span>App Store</span>
        </div>
      </div>
    </section>

    <section class="download-desc">
      {{ $t("ios.desc_1") }}
      <div v-if="$i18n.locale === 'zh'">
        <span class="symbol">* </span>
        <span>{{ $t("ios.desc_3") }}</span>
        <a
          href="https://www.yuque.com/docs/share/ad8a0309-43de-4743-9547-e8b3eeea8c72?#"
          target="_blank"
          style="color: #2980fe; text-decoration: none"
          v-if="language === 'zh'"
          >下载教程</a
        >
        <span v-if="language === 'zh'">。</span>
      </div>
    </section>

    <Description />

    <!-- <div class="divider"></div> -->
    <!-- <section class="download-wrap">
      <img class="download-logo" src="../assets/images/ios-testFlight.png" />
      <div class="download-content">
        <div class="download-title">
          TokenPocket
          <img class="download-samll-logo" src="../assets/images/ios-pro.png" />
        </div>
        <div class="download-version" v-if="versionInfo.ios_t">
          <span>TestFlight</span>
          V{{ versionInfo.ios_t }}
        </div>
      </div>
      <div class="download-btn">
        <span @click="goTestFlight">{{ $t("common.download") }}</span>
      </div>
    </section> -->

    <!-- <section class="download-desc">
      {{ $t("ios.desc_2") }}
    </section> -->

    <!-- <section class="download-desc download-text">
      <h4>{{ $t("ios.text_title_1") }}</h4>
      <p>{{ $t("ios.text_text_1_1") }}</p>
      <p>{{ $t("ios.text_text_1_2") }}</p>

      <h4>{{ $t("ios.text_title_2") }}</h4>
      <p>{{ $t("ios.text_text_2_1") }}</p>
      <p>{{ $t("ios.text_text_2_2") }}</p>
      <p>{{ $t("ios.text_text_2_3") }}</p>

      <h4>{{ $t("ios.text_title_3") }}</h4>
      <p>{{ $t("ios.text_text_3") }}</p>
      <p>
        (
        <a href="https://testflight.apple.com/">https://testflight.apple.com/</a
        >)
      </p>
    </section> -->
  </div>
</template>

<script>
import axios from "axios";
import LayoutHeader from "../components/LayoutHeader";
import Description from "../components/Description.vue";

import { mapGetters } from "vuex";
export default {
  name: "downloadIOS",
  components: {
    LayoutHeader,
    Description,
  },
  data() {
    return {
      versionInfo: {},
    };
  },

  computed: {
    ...mapGetters(["language"]),
  },

  methods: {
    goTestFlight() {
      window.location.href = "https://testflight.apple.com/join/4yN9AyXA";
    },

    goAppStore() {
      //   const url = this.language === 'zh'
      //     ? 'https://itunes.apple.com/hk/app/tokenpocket/id1436028697'
      //     : 'https://itunes.apple.com/us/app/tokenpocket/id1436028697'

      window.location.href =
        "https://itunes.apple.com/cn/app/tokenpocket-trusted-wallet/id1436028697";
    },
  },

  created() {
    axios
      .get("https://betaserver.mytokenpocket.vip/v1/version/last")
      .then((res) => {
        if (res.data.result === 0 && res.data.data !== null) {
          this.versionInfo = res.data.data;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
.download-bg {
  width: 100%;
}

.divider {
  margin: 28px 0.4rem 0;
  height: 0;
  border-top: 1px solid #e6e8ea;
}

.download-wrap {
  display: flex;
  align-items: center;
  padding: 0.58rem 0.4rem 0.3rem 0.3rem;

  .download-logo {
    width: 1.3rem;
    border-radius: 0.36rem;
  }

  .download-samll-logo {
    width: 0.57rem;
    margin-left: 0.2rem;
    //   vertical-align: middle;
  }

  .download-content {
    flex: 1;
    margin-left: 0.2rem;
  }

  .download-title {
    height: 0.45rem;
    font-size: 0.32rem;
    font-family: "PingFang-SC", sans-serif;
    font-weight: bold;
    color: rgba(58, 59, 61, 1);
    line-height: 0.45rem;
    display: flex;
    align-items: center;
  }

  .download-version {
    height: 0.37rem;
    font-size: 0.24rem;
    font-family: "PingFang-SC", sans-serif;
    font-weight: 500;
    color: #9ea0a5;
    line-height: 0.37rem;
    display: flex;
    align-items: center;
    margin: 0.15rem 0;
    span {
      font-size: 0.22rem;
      color: #2980fe;
      background: #e5f2fd;
      display: inline-block;
      text-align: center;
      padding: 0.04rem 0.1rem;
      margin-right: 0.15rem;
      border-radius: 0.08rem;
    }
  }

  .download-btn {
    display: flex;
    align-items: center;
    height: 0.78rem;
    background: #101010;
    border-radius: 0.12rem;
    box-shadow: 0 0.06rem 0.57rem 0 rgba(0, 77, 255, 0.1);
    padding: 0 0.2rem 0 0.25rem;
    .apple {
      width: 0.38rem;
      height: 0.44rem;
    }
    .right {
      margin-left: 0.18rem;
      display: flex;
      flex-direction: column;
      span {
        text-align: left;
        color: #ffffff;
      }
      :nth-child(1) {
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        line-height: 0.22rem;
      }
      :nth-child(2) {
        font-size: 0.26rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        line-height: 0.37rem;
      }
    }
  }
}

.download-desc {
  padding: 0.3rem 0.4rem;
  margin: 0 0.32rem 0.5rem;
  background: #f5f6f7;
  color: #3a3b3d;
  font-size: 0.26rem;
  font-family: "PingFang-SC", sans-serif;
  font-weight: 400;
  line-height: 0.37rem;
  display: block;
  border-radius: 0.12rem;
  line-height: 1.5;
  .symbol {
    color: #e55036;
  }
  span {
    font-size: 0.24rem;
    color: #666;
  }
  a {
    font-size: 0.24rem;
  }
}

.download-text {
  background: #f5f6f7;
  border-radius: 0.16rem;
  padding: 0.4rem;
  h4 {
    font-size: 0.26rem;
    font-family: "PingFang-SC", sans-serif;
    color: #3a3b3d;
    line-height: 0.37rem;
    margin-bottom: 0.14rem;

    &:not(:first-child) {
      margin-top: 0.3rem;
    }
  }

  p {
    font-family: "PingFang-SC", sans-serif;
    font-size: 0.22rem;
    color: #9ea0a5;
    line-height: 0.36rem;
  }

  a {
    text-decoration: none;
    color: #2980fe;
  }
}
@media screen and (max-width: 370px) {
  .download-wrap {
    .download-logo {
      width: 1.1rem;
    }
    .download-content {
      margin-left: 0.1rem;
    }
    .download-btn {
      padding: 0 0.1rem;
      .right {
        :nth-child(1) {
          font-size: 0.12rem;
        }
        :nth-child(2) {
          font-size: 0.22rem;
        }
      }
    }
  }
}
</style>
